<template>
  <v-dialog
    v-model="open"
    persistent
    max-width="800"
  >
    <v-card color="light" class="pl-5 pr-5 pt-2 pb-2">

      <v-toolbar
        dark
        color="light"
        elevation="0"
      >
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="open = false"
          color="accent"
          large
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <div class="text-center color-blue font-general-r">
          <h4>
            ¡Estas a punto de inscribirte a esta experiencia increíble, nunca te faltará Nieve de Olla en casa!
            Se te hará un cobro mensual por el Itacate elegido, puedes modificar o cancelar tu suscripción en el momento que quieras!
          </h4>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          elevation="0"
          class="nv-btn nv-btn-medium"
          @click="open = false"
        >
          CONTINUAR
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ["message"],
  data() {
    return {
      open: false
    }
  },
  computed: {
    ...mapState(['cart', 'user', 'is_auth'])
  },
  methods: {
    openDialog() {
      this.open = true;
    },
    close() {
      this.open = false;
    }
  }
}
</script>

<style scoped>
  .img-popup-message {
    width: 150px
  }
</style>
